<div class="headerStyle" *ngIf="!isDashboardHeader && !isCircleHeader">
    <div
        style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 1.5rem; margin-right: 0px; margin-left: 0px"
    >
        <div>
            <h1 translate>{{ this.title }}</h1>
            <h4 translate>{{ this.subTitle }}</h4>
            <h6 translate>{{ this.subSubTitle }}</h6>
            <div *ngIf="this.quotationOrIndustryDescri && this.quotationOrIndustryDescri.length > 0">
                <h6>{{ this.quotationOrIndustryDescri }}</h6>
            </div>
        </div>
        <div style="margin-right: 2rem">
            <button
                mat-icon-button
                class="button-icon-text"
                color="accent"
                (click)="navigateService.navigateHelp()"
                matTooltip="{{ 'HELPCENTER.HELP_CENTER' | translate }}"
                matTooltipClass="tooltip-layout"
                class="button-icon-text-header"
            >
                <mat-icon>help_outline</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="headerStyle" *ngIf="isCircleHeader">
    <div
        style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 1.5rem; margin-right: 0px; margin-left: 0px"
    >
        <div style="display: flex; flex-direction: row">
            <div>
                <div class="circleUser">{{ FullName?.trim().slice(0, 2).toLocaleUpperCase() }}</div>
            </div>
            <div *ngIf="isDashboardHeader" style="margin-left: 3rem" class="text-left">
                <h1 translate>MENU.DASHBOARD</h1>
                <h4><span translate>COMMONS.WELCOME</span>, {{ FullName }}</h4>
            </div>
            <div *ngIf="!isDashboardHeader" style="margin-left: 3rem; margin-top: 1.5rem" class="text-left">
                <h1 translate>{{ this.title }}</h1>
            </div>
        </div>
        <div style="margin-right: 2rem">
            <button
                mat-icon-button
                class="button-icon-text"
                color="accent"
                (click)="navigateService.navigateHelp()"
                matTooltip="{{ 'HELPCENTER.HELP_CENTER' | translate }}"
                matTooltipClass="tooltip-layout"
                class="button-icon-text-header"
            >
                <mat-icon>help_outline</mat-icon>
            </button>
        </div>
    </div>
</div>
